import { getAuthenticatedUser, getCookie, setCookie } from '.'

export const getAuthHeaders = async (
  csrftoken = false
): Promise<Record<string, string>> => {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  }

  // Get token from cookies
  let idToken = getCookie('idToken')
  let accessToken = getCookie('accessToken')

  // Fallback to alternate cookie names
  if (!idToken) {
    idToken = getCookie('docu.idToken')
    accessToken = undefined
  }

  if (idToken) {
    headers['Authorization'] = `Bearer ${idToken}`
    if (accessToken) headers['X-Access-Token'] = accessToken
  } else {
    // Try fetching from session
    try {
      const user = await getAuthenticatedUser()
      const sessionIdToken = user?.session?.idToken?.toString() ?? ''
      const sessionAccessToken = user?.session?.accessToken?.toString() ?? ''

      if (sessionIdToken) {
        headers['Authorization'] = `Bearer ${sessionIdToken}`
        setCookie('idToken', sessionIdToken, 0.5)
      }

      if (sessionAccessToken) {
        headers['X-Access-Token'] = sessionAccessToken
        setCookie('accessToken', sessionAccessToken, 0.5)
      }
    } catch (error) {
      console.debug('Not authenticated:', error)
    }
  }

  // CSRF Token
  if (csrftoken) {
    let csrf = getCookie('csrftoken')

    if (!csrf) {
      try {
        const { VITE_DOCUENGINE_PROTOCOL, VITE_DOCUENGINE_FQDN, VITE_DOCUENGINE_PORT, VITE_DOCUENGINE_CSRF_PATH } = import.meta.env

        if (
          !VITE_DOCUENGINE_PROTOCOL ||
          !VITE_DOCUENGINE_FQDN ||
          !VITE_DOCUENGINE_PORT ||
          !VITE_DOCUENGINE_CSRF_PATH
        ) {
          throw new Error('Missing required env vars for CSRF fetch')
        }

        const url = `${VITE_DOCUENGINE_PROTOCOL}://${VITE_DOCUENGINE_FQDN}:${VITE_DOCUENGINE_PORT}${VITE_DOCUENGINE_CSRF_PATH}`

        const res = await fetch(url, {
          method: 'GET',
          headers,
          credentials: 'include' // Required if server sets cookie
        })

        if (!res.ok) throw new Error(`CSRF fetch failed with status ${res.status}`)

        // Server should set the 'csrftoken' cookie
        await res.json()
        csrf = getCookie('csrftoken')
      } catch (err) {
        console.debug('Failed to fetch CSRF token:', err)
      }
    }

    if (csrf) {
      headers['X-CSRFToken'] = csrf
    }
  }

  return headers
}
